module.exports = __webpack_public_path__ + "img/pos1-bg.8d7d8d16.jpg";